import { SvgProps } from "@/utils/types";

export const Bag = ({
  primaryColor = "#F66E09",
  secondaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="29"
    height="37"
    viewBox="0 0 29 37"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8.57709V36H28V8.57709L24.7193 10.3077L21.1392 8L17.872 10.2631L14.3953 8L10.9803 10.3077L7.39958 8L4.31156 10.3077L1 8.57709Z"
      fill={primaryColor}
    />
    <path d="M29 37H0V8H1.87386V35.1461H27.1261V8H29V37Z" fill={outlineColor} />
    <path
      d="M11.1088 10.9995C10.9241 10.9995 10.7401 10.9478 10.5808 10.8442L7.71847 8.97923L4.85547 10.8442C4.53691 11.0519 4.11797 11.0519 3.79941 10.8442L0.409055 8.63474C-0.0185882 8.35608 -0.128343 7.79939 0.162775 7.39099C0.454563 6.98322 1.03747 6.87777 1.46444 7.15579L4.32677 9.02077L7.18977 7.15579C7.50833 6.94807 7.92727 6.94807 8.24583 7.15579L11.1082 9.02077L13.9712 7.15579C14.2897 6.94807 14.7087 6.94807 15.0272 7.15579L17.8902 9.02077L20.7532 7.15579C21.0718 6.94807 21.4907 6.94807 21.8093 7.15579L24.6723 9.02077L27.5353 7.15579C27.9629 6.87713 28.5458 6.98258 28.8369 7.39099C29.1287 7.79939 29.0183 8.35608 28.5907 8.63474L25.1996 10.8436C24.8811 11.0507 24.4621 11.0507 24.1436 10.8436L21.2806 8.97859L18.4176 10.8436C18.099 11.0513 17.6801 11.0513 17.3615 10.8436L14.4985 8.97859L11.6355 10.8436C11.4762 10.9471 11.2922 10.9989 11.1075 10.9989L11.1088 10.9995Z"
      fill={outlineColor}
    />
    <path
      d="M22 8H20.1757C20.1757 4.66198 17.6294 1.94596 14.5 1.94596C11.3706 1.94596 8.82434 4.66198 8.82434 8H7C6.99935 3.58891 10.364 0 14.4993 0C18.6347 0 21.9993 3.58891 21.9993 8H22Z"
      fill={outlineColor}
    />
    <mask
      id="mask0_989_66"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="13"
      width="15"
      height="17"
    >
      <path d="M21.2325 13.8349H7.5332V29.9756H21.2325V13.8349Z" fill="white" />
    </mask>
    <g mask="url(#mask0_989_66)">
      <path
        d="M14.3845 28.6966C14.3845 28.6966 15.0537 29.3278 16.3186 29.3278C19.4841 29.3278 21.8552 22.3808 19.8521 19.9055C17.8484 17.4303 14.3617 19.4861 14.3617 19.4861C14.3617 19.4861 10.9212 17.4336 8.91749 19.9055C6.91379 22.3775 9.2849 29.3278 12.4511 29.3278C13.7159 29.3278 14.3851 28.6966 14.3851 28.6966H14.3845Z"
        fill={secondaryColor}
      />
      <path
        d="M16.3184 29.9756C15.4277 29.9756 14.7785 29.7144 14.3843 29.4867C13.9902 29.7144 13.341 29.9756 12.4502 29.9756C10.9532 29.9756 9.52301 28.786 8.52986 26.7102C7.4303 24.4132 7.03612 21.1979 8.41408 19.5021C10.1394 17.3708 12.8879 18.002 14.3649 18.752C15.8553 18.0053 18.63 17.3741 20.3553 19.5021C21.7292 21.2006 21.3357 24.4132 20.2395 26.7102C19.2463 28.7854 17.8189 29.9756 16.3184 29.9756ZM14.8247 28.2237C14.8548 28.2504 15.3614 28.6832 16.3184 28.6832C17.2754 28.6832 18.3121 27.7381 19.0703 26.1518C20.1137 23.9737 20.2361 21.4096 19.3487 20.3123C17.7165 18.2965 14.723 20.0251 14.6929 20.0411C14.4874 20.16 14.2358 20.16 14.0303 20.0411C13.9112 19.9716 11.0435 18.3125 9.42061 20.3123C8.5332 21.4063 8.65568 23.9711 9.69901 26.1485C10.4573 27.7314 11.4839 28.6798 12.4509 28.6798C13.418 28.6798 13.9246 28.237 13.9446 28.2203C14.1929 27.9986 14.5771 27.9959 14.822 28.2203L14.8254 28.2237H14.8247Z"
        fill={outlineColor}
      />
      <path
        d="M14.3813 19.9423C14.05 19.9423 13.7656 19.6878 13.7355 19.3505C13.4738 16.383 15.3911 15.2061 15.4741 15.1567C15.782 14.9717 16.1795 15.0739 16.3615 15.3811C16.5436 15.685 16.4479 16.0817 16.1427 16.2634C16.0764 16.3028 14.841 17.1197 15.0271 19.2376C15.0572 19.5943 14.7955 19.9082 14.4375 19.9382H14.3813V19.9416V19.9423Z"
        fill={outlineColor}
      />
    </g>
  </svg>
);
